import { useState } from 'react';
import QueryString from 'query-string';
import React, { useEffect } from 'react';
import { Redirect, withRouter } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";

import { Http } from "../../../../support";
import DecimalAmount from '../../../../support/DecimalAmount';
import LoadingButton from "../../../../facturotopia/LoadingButton";
import PageHeader from "../../../../support/page-header/PageHeader";
import ResponseError from "../../../../shared/responses/ResponseError";
import ManageCardForm from './../../../../shared/checkout/ManageCardForm';

const CardPaymentForm = (props) => {
  const { billing = {}, data = {} } = props;

  const [query] = useState(QueryString.parse(props.location.search));
  const [error, setError] = useState();
  const [success, setSuccess] = useState();
  const [loading, setLoading] = useState(false);
  const [licencia] = useState(query.licencia || 'm');
  const [creditCard, setCreditCard] = useState({
    hasRegisteredCard: query.compra === '1' || !!data.payment,
    isValidCreditCard: !!data.payment,
    useCustomCard: false ,
    card: {}
  });

  useEffect(() => {
    if (query.compra === "1" && !!data.payment?.pm_id) {
      handleSubmit();
    }
  }, [data.payment?.pm_id]) // eslint-disable-line

  const renderError = () => {

    return (
      <div className="result-container">
        <ResponseError
          title="Transferencia fallida"
          error={ error }
          onAction={ handleOnAction }
        />
      </div>
    );
  }

  const handleOnAction= (action: string) => {
    if (action === 'reset') {
      setError();

      return;
    }
  }

  const handleSubmit = async () => {
    setLoading(true);

    const billingDetails = {
      name: billing.nombre,
      email: billing.email,
      phone: billing.phone,
      address: {
        city: billing.city,
        line1: billing.line1,
        state: billing.state,
        postal_code: billing.postal_code
      }
    };

    const { hasRegisteredCard, useCustomCard } = creditCard;

    const { error, payment } = (!hasRegisteredCard || useCustomCard) ? await creditCard.payment(billingDetails) : {
      payment: {
        pm_id: data.payment.pm_id
      }
    };

    if (error) {
      setError({
        ...error,
        error
      });

      return;
    }

    const { costo_anual, costo_mensual } = data;

    const param = {
      nombre: billing.nombre,
      email: billing.email,
      monto: licencia === 'y' ? costo_anual : costo_mensual,
      ...payment,
      paquete: {
        id: data.id,
        licencia: licencia
      }
    };

    const headers= {
      'X-Tenancy': 'fa/live'
    }

    try {
      const response = await Http.post(`api/paquetes/${data.id}/compras`, param, { headers });

      setSuccess(response);
    } catch (error) {
      setError({
        ...error.data
      });

      setLoading(false);
    }
  };

  const handleOnCreditCardChange = (event) => {
    setCreditCard({
      ...creditCard,
      isValidCreditCard: event.isValid,
      payment: event.payment,
    })
  }

  useEffect(() => {
    return () => {
      setLoading(false);
    }
  }, [success]);


  const landingPage = () => {
    let { from } = { from: { pathname: '/cuenta/consumo/' } };

    const search = props.location.search;

    let to = { pathname: `/cuenta/comprar/${success.id}/landing`, search: search };

    return <Redirect to={ to } state={ from } />;
  }

  const calculateMonto = () => {
    const { costo_anual, costo_mensual } = data;

    let total = 0;
    let iva = 0;

    if (licencia === 'y') {
      iva = parseFloat(costo_anual) * 0.16;

      total = parseFloat(costo_anual) + iva;
    } else {
      iva = parseFloat(costo_mensual) * 0.16;

      total = parseFloat(costo_mensual) + iva;
    }

    return DecimalAmount.make(total).toFixed(2);
  }

  const handleOnCustomCardClick = () => {
    setCreditCard({
      ...creditCard,
      isValidCreditCard: false,
      useCustomCard: !useCustomCard
    });
  }

  const { isValidCreditCard, useCustomCard } = creditCard;

  const buyLengendButton = !useCustomCard && !!data.payment
    ? `Pagar con ${data.payment.pm_type} ${data.payment.pm_last_four}`
    : 'Pagar con tarjeta'

  const {nombre, hits, costo_anual, costo_mensual} = data;
	const hitsVariable = licencia === 'y' ? hits * 12 : hits;

  return (
    <>
    { !!error && renderError() }

    { !!success && landingPage() }

    <PageHeader text="Paquetes" to="/cuenta/paquetes" />

    <Form autoComplete="off">
      <div className="max-width-350">
        <Row className="pt-1 pb-3">
          <Col>
            <div className="border-top border-bottom py-3">
              <Row className="">
                <Col sm="7">
                  <div className="d-block text-muted">{ nombre }</div>
                  <div className="d-block">{ hits === 'ilimitado' ? 'Hits ilimitados' : `${hitsVariable} hits` }</div>
                </Col>
                <Col className="text-right">
                  <div className="d-block">${ licencia === 'y' ? costo_anual : costo_mensual } <span className="text-muted">+ IVA</span></div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row className="text-right">
          <Col>
            <strong className="text-muted h5">Total</strong> <span className="h5">${ calculateMonto() }</span>
          </Col>
        </Row>

        <div className="pt-4 pb-2">
          { (!data.payment || useCustomCard) && (
            <ManageCardForm onChange={ handleOnCreditCardChange }>
              Tu información de pago será guardado y podrás usarlo en futuras compras. Puedes quitar tu información de pago desde "Mi licencia".
            </ManageCardForm>
          )}
          { !useCustomCard && !!data.payment && (
            <p>
              Se hará el cobro a tu tarjeta { ' ' }
              <strong>{ data.payment.pm_type }</strong> **** **** **** { data.payment.pm_last_four }
            </p>
          )}
        </div>
      </div>

      <Row>
        <Col>
          { !useCustomCard && (
            <Button variant="secondary"
              className="mr-2"
              onClick={ handleOnCustomCardClick }
            >
              Usar nueva tarjeta
            </Button>
          )}
          <LoadingButton type="button"
            variant="primary"
            disabled={ !isValidCreditCard }
            loading={ loading }
            onClick={ handleSubmit }
          >
            { loading ? 'Procesando pago...' : buyLengendButton }
          </LoadingButton>
        </Col>
      </Row>
    </Form>
    </>
  );
};

export default withRouter(CardPaymentForm);
